<template>
  <div>
    <v-layout row>
      <v-flex xs2>
        <v-text-field
          append-icon="search"
          label="Search by email"
          v-model="filterByEmail"
        />
      </v-flex>
    </v-layout>
    <!--{{getRegularInvitations}}-->
    <v-data-table
       v-if="getRegularInvitations"
      :items="getRegularInvitations.attendees"
      :headers="headers"
       :total-items="totalItemsInTable"
      :pagination.sync="pagination"
    >
      <!--need real params names-->
      <template slot="items" slot-scope="props">
        <td class="py-4">{{ props.item.email }}</td>
        <td class="py-4">{{ props.item.usedExtraTicketsCount }} / {{ props.item.extraTicketsCount }}</td>
        <td class="text-xs-center">
          <v-tooltip bottom>
            <v-btn
              color="blue darken-1"
              fab flat
              slot="activator"
              @click.stop="showRegisteredAttendees(props.item)"

            >
              <v-icon>remove_red_eye</v-icon>
            </v-btn>
            <span>See all registered attendees</span>
          </v-tooltip>
        </td>
        <td class="py-4">/registration/attendee?invitationToken={{ props.item.invitationToken }}</td>
      </template>
      <template slot="pageText" slot-scope="{}">
        Page {{pagination.page}} of {{getRegularInvitations.totalPages}}
      </template>
    </v-data-table>

    <v-dialog
      max-width="500px"
      persistent
      v-model="isRegisteredAttendeesModalShown"
      persistent
    >
      <v-card class="pa-4">
        <h3 class="mb-2">Attendees registered by regular invitation:</h3>
        <div v-for="attendee in registeredAttendees">
          <v-icon>done</v-icon> <b>{{attendee.firstName}} {{attendee.lastName}}</b> {{attendee.email}}
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: "regular-invitation",
  data () {
    return {
      filterByEmail: '',
      itemsOnPage: 5,
      isRegisteredAttendeesModalShown: false,
      registeredAttendees: null,
      pagination: {
        rowsPerPage: 5,
      },
      headers: [
        { text: 'Origin attendee', sortable: false, width: 50 },
        { text: 'Tickets used', sortable: false, width: 100 },
        { text: 'Registered attendees',  sortable: false, width: 50 },
        { text: 'Token', sortable: false, width: 50 }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'getRegularInvitations'
      ]),
    totalItemsInTable () {
      return this.getRegularInvitations.totalItems || (this.getRegularInvitations.totalPages * this.pagination.rowsPerPage)
    }
  },
  watch: {
    filterByEmail: {
      handler (newVal, oldVal) {
        this.sendRenewedRequest()
      },
      deep: true
    },
    pagination: {
      handler (newVal, oldVal) {
        this.sendRenewedRequest()
      },
      deep: true
    }
  },
  methods: {
    ...mapActions([
      'fetchRegularInvitations'
    ]),
    showRegisteredAttendees (item) {
      this.registeredAttendees = item.invitedAttendees
      this.isRegisteredAttendeesModalShown = true
    },
    sendRenewedRequest () {
      const { page, rowsPerPage } = this.pagination
      this.page = page - 1 || 0
      this.itemsOnPage = rowsPerPage || 5
      if (rowsPerPage === -1) this.itemsOnPage = this.totalItems
      let config = { page: this.page, itemsOnPage: this.itemsOnPage, email: this.filterByEmail}
      this.fetchRegularInvitations(config)
    }
  },
  async mounted () {
    await this.fetchRegularInvitations()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Registration/Attendee/RegularInvitation/index.vue